<template>
  <div class="main container">
    <loader :isLoading="isAgreementsRequestInProgress"/>

    <h2>Agreements</h2>
    <div class="line"></div>

    <!-- Create Agreement Button -->
    <div v-if="accountType === 'business'" class="create-section">
      <button type="button" class="btn create-btn d-flex flex-row" @click="goToCreateAgreement()">
        <img src="@/assets/img/icon-add.png">
        <div class="create-btn-title">New Agreement</div>
      </button>
    </div>
    <!-- End Create Agreement Button -->

    <section>
      <agreement-list-view
        :accountType="accountType"
        :agreementsData="getAgreementsData"
        :hasAgreements="hasAgreementsData"
        :editAgreement="editAgreement"
        :deleteAgreement="deleteAgreement"
        :goToNewTab="goToNewTab" />
    </section>

    <small data-type="message" class="form-text error-message">{{ errorMessage }}</small>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  DELETE_AGREEMENT,
  FETCH_AGREEMENTS
} from '@/store/types/actions.type'

import Loader from '@/components/common/Loader'

import AgreementListView from '@/components/listview/AgreementListView'

import { APIService } from '@/api/APIService'
import { AuthService } from '@/api/AuthService'

const api = new APIService()
const auth = new AuthService()

export default {
  components: {
    Loader,
    'agreement-list-view': AgreementListView,
  },
  computed: {
    ...mapGetters([
      'getAgreementsData',
      'hasAgreementsData',
      'fetchAgreementsError',
      'isAgreementsRequestInProgress'
    ])
  },
  data() {
    return {
      accountType: '',
      userId: auth.getUserId(),
      companyId: auth.getCompanyId(),
      errorMessage: ''
    }
  },
  mounted() {
    this.accountType = auth.getAccountType()
    if(this.accountType === 'individual')
      this.$router.push('/dashboard')

    this.getBusinessAgreements()
  },
  methods: {
    async checkIsAgreementIsUsed(aid) {
      const self = this
      const isUsed = await api.getPassWithGivenUserIdAndAgreementId(this.companyId, aid)
      if(isUsed.message === 'Agreement not used') {
        this.$store.dispatch(DELETE_AGREEMENT, aid)
        .then(d => { self.getBusinessAgreements() })
        .catch(e => { self.errorMessage = e })
      } else {
        this.errorMessage = 'Selected agreement is used in 1 or more passes'
        setTimeout(() => { self.errorMessage = '' }, 3000)
      }
    },
    goToCreateAgreement() {
      this.$router.push('/agreements/create')
    },
    editAgreement(e) {
      this.$router.push(`/agreements/edit/${e.id}`)
    },
    deleteAgreement(e) {
      this.checkIsAgreementIsUsed(e.id)
      // const self = this
      // this.$store.dispatch(DELETE_AGREEMENT, e.id)
      // .then(d => { self.getBusinessAgreements() })
      // .catch(e => { self.errorMessage = e })
    },
    goToNewTab(e){
      const url = `${window.location.origin}/agreements/view/${e.ref_code}`
      window.open(url, '_blank')
    },
    getBusinessAgreements() {
      this.$store.dispatch(FETCH_AGREEMENTS, this.companyId)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.create-btn {
  padding: 0px;
  align-items: center;
}
.create-btn img {
  width: 24px;
  margin-bottom: 0px;
}

.fas {
  border-radius: 50%;
  border: solid 1px #0091f4;
}
.create-btn-title {
  margin-left: 12px;
  font-size: 24px;
  font-family: 'HKGrotesk-Bold', Helvetica, sans-serif;
  color: #0091f4;
}
.create-section {
  padding-left: 0;
  padding-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/containers/dashboard/Agreements.vue